import cx from 'classnames';
import { CDN_CLRSAVE_URL } from '../../constants';

import styles from '../../styles/plan/sectionHeader.scss';

const SectionHeader = (props: any) => (
  <div
    className={cx(styles['section-header'], {
      [styles.mandate]: props.mandate,
    })}
  >
    <h2 className={cx('text--xlg', styles.header)}>
      {props.title}
      {props.golden && (
        <img
          className={styles.golden}
          src={`${CDN_CLRSAVE_URL}/clearsave/images/golden.png`}
          alt="star"
        />
      )}
    </h2>
    {props.action && (
      <label
        className={cx(styles['action-button'], 'text--xmd float-right')}
        onClick={props.action.onClick}
      >
        {props.action.text}
      </label>
    )}
  </div>
);

export default SectionHeader;



// WEBPACK FOOTER //
// ./components/plan/sectionHeader.tsx